import {
  rowsFragment
} from '../fragments.gql.js'

export default slug => `query {
  compositePdp(filter: {slug: {eq: "${slug}"}}) {
    compositeMeta: _seoMetaTags {
      attributes
      content
      tag
    }
    rowsBelowOverride: rowsBelow ${rowsFragment}
    compositeProducts: products {
      id
      sku
      swatchIconOverride {
        url(imgixParams: {w: "50", h: "50"})
      }
      baseProduct {
        id
        swatchIconOverride {
          url(imgixParams: {w: "50", h: "50"})
        }
        theme
        baseProduct {
          id
          sku
        }
      }
    }
    reviewsTitleOverride: reviewsTitle
    useBaseProductReviews
  }
}`